import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 40px 24px;
    border-radius: 16px;
    background-color: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 3px 6px 0 ${theme.v3.colors.neutral[90]}16, 0 4px 8px 0 ${theme.v3.colors.neutral[90]}22;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;    
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 750px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GatorIcon = styled.img`
  display: block;
  margin: 0;
  height: auto;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 20px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[40]};
    margin: 0;
    max-width: 450px;
  `}
`;
